import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { KeyRound, ArrowRight } from 'lucide-react';
import PricingTableSection from '../components/programs/PricingTableSection';
import { programRoutes } from '../data/mock';

const otherRoutes = programRoutes.filter((r) => r.id === 'first-splash' || r.id === 'foundations');

export default function PriorityEnrollment() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <main data-testid="priority-enrollment-page">
      <section className="pt-16 pb-6">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-splash-coral text-white px-4 py-1.5 text-xs uppercase tracking-widest font-semibold">
            <KeyRound className="w-3.5 h-3.5" /> Priority Access
          </div>
          <h1 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-splash-green leading-tight">Welcome back &mdash; your spot comes first.</h1>
          <p className="mt-5 text-splash-green/80 text-lg leading-relaxed">
            As a current or waitlist family, you get early access to Winter 2026&ndash;27 enrollment starting <strong className="text-splash-green">October 23, 2026</strong> &mdash; one week before public enrollment opens on October 30. Please don&rsquo;t share this page publicly.
          </p>
        </div>
      </section>
      <PricingTableSection />
      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="font-display font-bold text-2xl md:text-3xl text-splash-green text-center mb-6">Enrolling a younger swimmer?</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {otherRoutes.map((r) => (
              <Link key={r.id} to={r.to} data-testid={`priority-link-${r.id}`} className="group rounded-3xl bg-white border border-splash-sand p-6 card-hover">
                <div className="text-[11px] uppercase tracking-widest font-semibold text-splash-coral">{r.ages}</div>
                <div className="mt-1 font-display font-bold text-2xl text-splash-green">{r.title}</div>
                <p className="mt-2 text-sm text-splash-green/75">{r.blurb}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-splash-teal font-semibold text-sm">View &amp; enroll <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
